export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '拼团房间奖励';